// extracted by mini-css-extract-plugin
export var compactFilters = "_ep-4";
export var detailImage = "_ep-1";
export var dropdownContainer = "_ep-2";
export var imageContainer = "_ep-0";
export var selectedCard = "_ep-3";